module.exports = __webpack_public_path__ + "static/media/Ion-Solar-Logo-white.ff8e70fc.svg";